import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import ParentCategory from 'modules/budget/components/category/category-table/parent-category';

class ParentCategories extends Component {
    render() {
        const { categories, hidden } = this.props;
        return categories.map((category) => <ParentCategory key={category.id} category={category} hidden={hidden} />);
    }
}

ParentCategories.propTypes = {
    /** An array of Parent Categories to list */
    categories: PropTypes.any,

    /** Whether this component is displaying hidden categories */
    hidden: PropTypes.bool,
};

export default observer(ParentCategories);


// WEBPACK FOOTER //
// ./src/modules/budget/components/category/category-table/parent-categories.js